import * as React from "react";

export default class RespondInviteGroupComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="desc">
          Join to collaborate on research with Group members.
        </div>
      </div>
    );
  }
}
